import { useState, useEffect, useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { notificariAPI, getAccessToken } from '../services/api';
import { useAuth } from '../context/AuthContext';

export function useNotificari() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const [ws, setWs] = useState(null);

  const { data, refetch } = useQuery(
    'notificari',
    () => notificariAPI.list().then(r => r.data),
    { enabled: !!user, refetchInterval: 60000 }
  );

  // WebSocket pentru notificări real-time
  useEffect(() => {
    if (!user) return;
    const token = getAccessToken();
    if (!token) return;

    const wsUrl = `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws?token=${token}`;
    const socket = new WebSocket(wsUrl);

    socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        if (msg.tip === 'STATUS_UPDATE') {
          // Invalidăm cache-ul pentru cereri și notificări
          queryClient.invalidateQueries('notificari');
          queryClient.invalidateQueries('cereri');
          queryClient.invalidateQueries(['cerere', msg.cerere?.id]);
        }
      } catch {}
    };

    socket.onclose = () => {
      // Reconectare după 5s dacă conexiunea se pierde
      setTimeout(() => { setWs(null); }, 5000);
    };

    setWs(socket);
    return () => socket.close();
  }, [user, queryClient]);

  const markRead = useCallback(async (id) => {
    await notificariAPI.markRead(id);
    refetch();
  }, [refetch]);

  const markAllRead = useCallback(async () => {
    await notificariAPI.markAllRead();
    refetch();
  }, [refetch]);

  return {
    notificari: data?.data || [],
    necitite:   data?.necitite || 0,
    markRead,
    markAllRead,
    refetch,
  };
}
